<template>
    <!-- /reg 의 유일한 문의 창. 하단 '문의하기' 버튼과 신청 실패 모달의 '문의하기' 가 같은 창을 연다. -->
    <b-modal :id="modalId"
             :title="$t(`평가 신청 관련 문의하기`)"
             size="lg"
             hide-footer
             centered
             @show="prefill"
    >
        <div class="text-center">
            <p class="f-110 font-weight-bold mt-3 mb-4">{{ $t('아래 사항을 입력해주시면 최대한 빠르게 해결 도와드리겠습니다.') }}</p>
        </div>
        <div class="group-inputs">
            <b-row class="mb-3">
                <b-col cols="6">
                    <label for="inquiry-name" class="d-block gray-600 mb-1"> {{ $t(`성함`) }} *</label>
                    <b-form-input id="inquiry-name" v-model="form.name" type="text"/>
                </b-col>
                <b-col cols="6">
                    <label for="inquiry-company" class="d-block gray-600 mb-1">{{ $t(`소속`) }} *</label>
                    <b-form-input id="inquiry-company" v-model="form.company" type="text" :placeholder="$t('회사')"/>
                </b-col>
            </b-row>
            <!-- 연락처·이메일은 둘 중 하나만 있으면 된다 -->
            <b-row class="mb-1">
                <b-col cols="6">
                    <label for="inquiry-contact" class="d-block gray-600 mb-1">{{ $t(`연락처`) }}</label>
                    <b-form-input id="inquiry-contact" v-model="form.contact" type="text"/>
                </b-col>
                <b-col cols="6">
                    <label for="inquiry-email" class="d-block gray-600 mb-1">{{ $t(`이메일`) }}</label>
                    <b-form-input id="inquiry-email" v-model="form.email" type="email" placeholder="name@example.com"/>
                </b-col>
            </b-row>
            <b-form-text class="mb-3">{{ $t('평가신청을 도와드릴 수 있도록 연락처 또는 이메일 중 1개는 적어주셔야합니다.') }}</b-form-text>
            <b-row>
                <b-col cols="12" class="mb-3">
                    <label for="inquiry-message" class="d-block gray-600 mb-1">{{ $t(`문의사항`) }} *</label>
                    <b-textarea id="inquiry-message" v-model="form.message" rows="6"
                                :placeholder="$t(`업체 코드(vendor code)를 기입 후 문의해 주시면 빠른 확인 가능합니다. 문의사항을 작성해 주세요.`)"/>
                </b-col>
                <b-col v-if="!sending" cols="12" class="text-right">
                    <b-btn variant="outline-secondary" @click="$bvModal.hide(modalId)">{{ $t('취소') }}</b-btn>
                    <b-button class="ml-2" variant="blue" @click="send">
                        {{ $t(`문의하기`) }}
                        <fa icon="paper-plane" class="ml-1"/>
                    </b-button>
                </b-col>
                <b-col v-else cols="12" class="text-center">
                    <b-spinner small/>
                    {{ $t(`문의사항을 전송하는 중입니다. 잠시 기다려 주세요.`) }}
                </b-col>
            </b-row>
        </div>
    </b-modal>
</template>

<script>
import {mapState} from 'vuex';

export const REGISTER_INQUIRY_MODAL_ID = 'register-inquiry-modal';

export default {
    name: 'RegisterInquiryModal',
    data() {
        return {
            modalId: REGISTER_INQUIRY_MODAL_ID,
            form: {name: '', company: '', contact: '', email: '', message: ''},
            sending: false,
        };
    },
    computed: {
        ...mapState('register', ['selected_vendor']),
    },
    methods: {
        // 열 때 고른 업체가 있으면 소속을 채워 둔다. 이미 쓴 내용은 지우지 않는다.
        prefill() {
            if (!this.form.company) {
                this.form.company = this.selected_vendor?.company?.company_name || '';
            }
        },
        validate() {
            const {name, company, contact, email, message} = this.form;
            if (!name) return this.$t('평가신청을 도와드릴 수 있도록 담당자분의 성함을 입력해주세요.');
            if (!company) return this.$t('평가신청을 도와드릴 수 있도록 회사 이름을 입력해주세요.');
            if (!contact && !email) return this.$t('평가신청을 도와드릴 수 있도록 연락처 또는 이메일 중 1개는 적어주셔야합니다.');
            // 잘못 쓴 이메일로 접수되면 답변을 받을 수 없다 (RegisterJoinRequest 와 같은 형식 검사)
            if (email && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.trim())) return this.$t('이메일을 정확히 입력하여 주십시오.');
            if (!message) return this.$t('문의사항을 기입해주시면 감사하겠습니다.');
            return null;
        },
        async send() {
            const problem = this.validate();
            if (problem) {
                this.$showModal({type: 'alert', state: 'warning', title: this.$t('알림'), message: problem});
                return;
            }

            const {name, company, email, contact, message} = this.form;
            const formData = new FormData();
            formData.append('name', name);
            formData.append('company', company);
            formData.append('mobile', contact);
            formData.append('e_mail', email);
            formData.append('requirements', message);
            formData.append('source', 'qesg_assessment');

            this.sending = true;
            try {
                await this.$axios.post('/save_customer_service', formData);
                this.$EventBus.$emit('toast-success', this.$t('알림'), this.$t('장애사항을 접수하였습니다. 최대한 빠르게 답변드리도록 하겠습니다.'));
                // 접수(저장)가 끝났으면 안내 메일 실패는 사용자 문제로 만들지 않는다
                await this.$axios.post('/send_customer_service_mail', formData).catch(() => {});
                this.form = {name: '', company: '', contact: '', email: '', message: ''};
                this.$bvModal.hide(this.modalId);
            } catch (e) {
                this.$EventBus.$emit('toast-failure', this.$t('알림'), this.$t('문의 접수에 실패했습니다. 잠시 후 다시 시도해주세요.'));
            } finally {
                this.sending = false;
            }
        },
    },
};
</script>
